import React, { useState } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import ComposedChart from "src/components/Charts/ComposedChart";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { IndicatorsGroupers } from "src/pages/Indicators/Panel/interface";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { colorChart, IDashboardIndicatorsDataChart } from "../interface";
import { FilterButton, FilterButtonSelected } from "./styles";

const DashboardChartIndicators: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	const [actualPeriod, setActualPeriod] = useState<boolean>(true);
	const [dataIndicators, setDataIndicators] = useState<IDashboardIndicatorsDataChart[]>([] as IDashboardIndicatorsDataChart[]);

	const returnName = (value?: string) => {
		if(value === "E")
			return translate("Estratégico");
		if(value === "T")
			return translate("Tático");
		return translate("Operacional");
	};

	const { loading } = useEffectFetchData<IDashboardIndicatorsDataChart[]> (
		"DashboardIndicators/List", 
		{ 
			group: true,
			actualPeriod 
		},
		({ data }) => {
			if(data && data.length > 0){
				setDataIndicators(data.map((dt: IDashboardIndicatorsDataChart) => ({
					...dt,
					name: returnName(dt.group),
					color: {
						...colorChart
					} 
				})));
			}
		}, [actualPeriod]
	);

	const dataCard = dataIndicators && dataIndicators.length > 0 ? dataIndicators : [{
		total:0, 
		withoutValue: 0,
		notOnTarget:0,
		onTarget:0,
		groupId: 0,
		name: ""
	}];	

	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Gráfico Indicadores por Nível")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<RCCGrid container justifyContent="flex-end">
					<RCCTooltip
						text={translate("Período anterior")}
						color="blue"
						styleInline={actualPeriod === false ? FilterButtonSelected : FilterButton}
					>
						<RCCButton 
							color="blue"
							styleInline={actualPeriod === false ? FilterButtonSelected : FilterButton}
							onClick={(e) => { e.stopPropagation(); setActualPeriod(false); }}
						>
							{translate("Anterior")}
						</RCCButton>
					</RCCTooltip>
					<RCCTooltip
						text={translate("Período atual")}
						color="purple" 
						styleInline={actualPeriod === true ? FilterButtonSelected : FilterButton}
					>
						<RCCButton 
							color="purple" 
							styleInline={actualPeriod === true ? FilterButtonSelected : FilterButton}
							onClick={(e) => { e.stopPropagation(); setActualPeriod(true); }}
						>
							{translate("Atual")}
						</RCCButton>
					</RCCTooltip>
				</RCCGrid>
				<Link to={`/indicators/panel/?group=${IndicatorsGroupers.LEVEL}`} >
					<RCCTooltip
						text={translate("Painel de indicadores")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="indicators"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
				<Link to="/indicators/presentation">
					<RCCTooltip
						text={translate("Apresentação de indicadores")}
						color="grey"
					>
						<RCCButton 
							color="transparent"
							icon={{
								name: "presentationChartBar",
								color: "var(--app-icons-color)"
							}}
						/>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>

			{dataCard.length > 0 ? (
				<RCCGrid container justifyContent="center" style={{height: "300px"}}>
					<ComposedChart
						data={dataCard as any}
						width={500}
						height={400}
						xAxis={{
							scale: "band"
						}}
						yAxis={[]}
						colorsPallete={colorChart}
						bar={[{
							dataKey: "total",
							barSize: 20,
							name: "Total",
							label: { position: "top" }
						  },{
							dataKey: "withoutValue",
							barSize: 20,
							name: translate("Sem valor"),
							label: { position: "top" }
						  },{
							dataKey: "notOnTarget",
							barSize: 20,
							name: translate("Não atingiu"),
							label: { position: "top" }
						  },{
							dataKey: "onTarget",
							barSize: 20,
							name: translate("Atingiu a meta"),
							label: { position: "top" }
						  }]}
					/>
				</RCCGrid>
			): (
				<DefaultBody>
					<RCCAlert 
						title={translate("Atenção")}
						description={translate("Não foram encontrados resultados para esta pesquisa")}
					/>
				</DefaultBody>
			)}
		</DefaultContainer>
	);
};

export default DashboardChartIndicators;
